import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeBannerInitialState, handlePaginationState } from "../../../store/masters/mastersSlice";
import sansthaApis from "../../../store/sanstha/sansthaApis";

const mapStateToProps = (state) => {
    return {
        formType: state.masters.formType,
        bannerInitialValue: state.masters.bannerInitialValue,
        showDrawer: state.masters.showDrawer,
        pagination: state.masters.pagination,
    };
};

const mapDispatch = {
    changeBannerInitialState,
    handlePaginationState,
    getSansthaList: sansthaApis.endpoints.getSansthaList.initiate,
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(mapDispatch, dispatch);

const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;